import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import CoursesContent from './CoursesContent'
import RatingsContent from './RatingsContent'
export default class Ratings extends Component {



    render() {
        
        let page = this.props.match.params.page;
        const urlParams = new URLSearchParams(window.location.search);

        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <RatingsContent urlParams={urlParams} page={page} />
                <Footer />

            </div>


        )
    }
}
